<template>
  <img
    src="../../../../../assets/images/png/pendant_light_A_off_button_black.png"
  />
</template>
